import { put } from 'redux-saga/effects'
import { authApi } from '../../api'
import { ILoginResponse } from '../../types/auth'
import LocalStorageService from '../../services/LocalStorageService'
import { loginSuccess, loginFailure, logoutSuccess, logoutFailure } from './userActions'
import { LoginAction } from './userTypes'

export function* loginSaga({ payload }: LoginAction) {
  try {
    const { username, password } = payload

    const user: ILoginResponse = yield authApi.login(username, password)
    LocalStorageService.setAuthToken(user.accessToken)

    yield put(loginSuccess(user))
  } catch (error) {
    yield put(loginFailure())
  }
}

export function* logoutSaga() {
  try {
    LocalStorageService.removeAuthToken()

    yield put(logoutSuccess())
  } catch (error) {
    yield put(logoutFailure())
  }
}
